var _cuPos=0;
function cuSlide(d){
  var t=document.getElementById('cu-track');
  if(!t||!t.children[0])return;
  var tot=t.children.length,max=Math.max(0,tot-2),cw=t.children[0].offsetWidth+10;
  _cuPos=Math.max(0,Math.min(_cuPos+d,max));
  t.style.transform='translateX('+(_cuPos*cw)+'px)';
  var p=document.getElementById('cu-prev'),n=document.getElementById('cu-next');
  if(p)p.disabled=_cuPos<=0;
  if(n)n.disabled=_cuPos>=max;
}
function cuMoney(cents){return (cents/100).toFixed(2)+' ₪';}
function cuHideCodes(){
  var els=document.querySelectorAll('.discounts__discount, .cart-discount, .cart-item__discount, .discounts li');
  els.forEach(function(el){
    if(el.style.display!=='none' && /CU-/i.test(el.textContent||'')) el.style.display='none';
  });
}
function cuFindVariant(card){
  var script=card.querySelector('.cu__vdata');
  if(!script)return null;
  var variants;
  try{variants=JSON.parse(script.textContent);}catch(e){return null;}
  var sels=card.querySelectorAll('.cu__opt'),chosen=[];
  sels.forEach(function(s){chosen.push(s.value);});
  for(var i=0;i<variants.length;i++){
    var v=variants[i],match=true;
    for(var j=0;j<chosen.length;j++){if(v.o[j]!==chosen[j]){match=false;break;}}
    if(match)return v;
  }
  return null;
}
function cuOpt(sel){
  var card=sel.closest('.cu__card');if(!card)return;
  var v=cuFindVariant(card);if(!v)return;
  var btn=card.querySelector('.cu__btn');
  var disc=btn?Number(btn.getAttribute('data-disc'))||0:0;
  if(btn){
    btn.setAttribute('data-vid',v.id);
    if(!v.a){btn.disabled=true;btn.textContent='אזל';}
    else if(btn.getAttribute('data-added')!=='1'){btn.disabled=false;btn.textContent='+ הוסף';}
  }
  var dprice=disc>0?Math.round(v.p*(100-disc)/100):v.p;
  var pe=card.querySelector('.cu__price'),ce=card.querySelector('.cu__compare');
  if(pe)pe.textContent=cuMoney(dprice);
  if(ce&&disc>0)ce.textContent=cuMoney(v.p);
}
function cuSizeModal(){
  var m=document.getElementById('cu-size-modal');
  if(m)return m;
  m=document.createElement('div');
  m.id='cu-size-modal';
  m.style.cssText='display:none;position:fixed;inset:0;z-index:2147483000;align-items:center;justify-content:center;padding:16px;';
  m.innerHTML='<div style="position:absolute;inset:0;background:rgba(0,0,0,.7);"></div>'+
    '<div style="position:relative;max-width:520px;width:100%;max-height:85vh;background:#fff;border-radius:12px;padding:10px;overflow:auto;z-index:1;">'+
      '<button type="button" style="position:absolute;top:6px;left:6px;width:32px;height:32px;border:none;border-radius:50%;background:#111;color:#fff;font-size:20px;line-height:1;cursor:pointer;z-index:2;">&times;</button>'+
      '<img alt="טבלת מידות" style="display:block;width:100%;height:auto;border-radius:8px;">'+
    '</div>';
  document.body.appendChild(m);
  m.children[0].addEventListener('click',cuSizeClose);
  m.querySelector('button').addEventListener('click',cuSizeClose);
  return m;
}
function cuSizeOpen(src){
  var m=cuSizeModal();
  m.querySelector('img').src=src;
  m.style.display='flex';
  document.addEventListener('keydown',cuSizeEsc);
}
function cuSizeClose(){
  var m=document.getElementById('cu-size-modal');
  if(m)m.style.display='none';
  document.removeEventListener('keydown',cuSizeEsc);
}
function cuSizeEsc(e){if(e.key==='Escape')cuSizeClose();}
function _cuRefresh(){
  fetch('/?sections=cart-drawer').then(function(r){return r.json();}).then(function(d){
    if(!d['cart-drawer'])return;
    var tmp=document.createElement('div');tmp.innerHTML=d['cart-drawer'];
    var ni=tmp.querySelector('#CartDrawer-CartItems'),oi=document.querySelector('#CartDrawer-CartItems');
    if(ni&&oi)oi.innerHTML=ni.innerHTML;
    var nt=tmp.querySelector('.totals__total-value'),ot=document.querySelector('.totals__total-value');
    if(nt&&ot)ot.textContent=nt.textContent;
    var nc=tmp.querySelector('.cart-count-bubble span');
    if(nc)document.querySelectorAll('.cart-count-bubble span').forEach(function(el){el.textContent=nc.textContent;});
    cuHideCodes();
  }).catch(function(){document.dispatchEvent(new CustomEvent('cart:refresh',{bubbles:true}));});
}
function cuAdd(btn,code){
  var adding=btn.getAttribute('data-added')!=='1';
  var vid;
  if(adding){
    vid=btn.getAttribute('data-vid');
    btn.setAttribute('data-added-vid',vid);
  }else{
    vid=btn.getAttribute('data-added-vid')||btn.getAttribute('data-vid');
  }
  btn.disabled=true;btn.textContent='...';
  var url=adding?'/cart/add.js':'/cart/update.js';
  var body;
  if(adding){body={id:Number(vid),quantity:1};}
  else{body={updates:{}};body.updates[vid]=0;}
  fetch(url,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(body)})
    .then(function(r){return r.ok?r.json():Promise.reject(r.status);})
    .then(function(){
      if(adding&&code){return fetch('/discount/'+encodeURIComponent(code),{method:'GET'}).then(function(){}).catch(function(){});}
    })
    .then(function(){
      if(adding){btn.textContent='הסר';btn.classList.add('cu__btn--remove');btn.setAttribute('data-added','1');}
      else{btn.textContent='+ הוסף';btn.classList.remove('cu__btn--remove');btn.removeAttribute('data-added');}
      btn.disabled=false;
      _cuRefresh();
    })
    .catch(function(){btn.textContent='שגיאה';btn.disabled=false;});
}
setTimeout(function(){
  var t=document.getElementById('cu-track'),n=document.getElementById('cu-next');
  if(n&&t)n.disabled=(t.children.length<=2);
},150);
cuHideCodes();
document.addEventListener('DOMContentLoaded',cuHideCodes);
(function(){
  if(!window.MutationObserver)return;
  var target=document.querySelector('cart-drawer')||document.getElementById('CartDrawer')||document.body;
  if(!target)return;
  new MutationObserver(function(){cuHideCodes();}).observe(target,{childList:true,subtree:true});
})();